import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'environments/environment';


@Component({
  selector: 'annali',
  templateUrl: './annali.component.html',
  styleUrls: ['./annali.component.scss']
})
export class AnnaliComponent implements OnInit {
  
  navigazioneAnnali= 0

  years1 = Array.from({ length: 22 }, (_, i) => 1921 + i); // Array da 1921 a 1942
  years2 = Array.from({ length: 8 }, (_, i) => 1943 + i); // Array da 1943 a 1950
  years3 = Array.from({ length: 49 }, (_, i) => 1951 + i); // Array da 1951 a 1999

  // Base per i PDF (dominio pubblico, non l'API con porta)
  websiteUrl = `${environment.publicSiteBase}/docs/DVDannali/`;

  
  constructor() { }

  ngOnInit() {
  }

  titoloSezione(sezione){
    switch (sezione) {
      case 0:
        return "Indice"
      case 1:
        return ""
      case 2:
        return "Gli annali"
      case 3:
       return  "Le pubblicazioni"
      case 4:
        return "Le pubblicazioni"
      default:
        ""
    }
    
  }

  updateNavigation(sezione){
    this.navigazioneAnnali = sezione
  }

  openPdfDocument(pdfUrl: string): void {
    const pdfUrlWithParams = `${pdfUrl}#view=FitH&navpanes=0&scrollbar=0`;
    const win = window.open('', '_blank', 'left=20,top=20,width=1000,height=800,resizable=1');
    if (!win) {
      return;
    }
    const escapedUrl = pdfUrlWithParams.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const html = `<!DOCTYPE html>
<html lang="it">
<head>
  <meta charset="utf-8" />
  <meta http-equiv="X-UA-Compatible" content="IE=edge" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <title>Documento PDF</title>
  <style>
    html, body { height: 100%; margin: 0; overflow: hidden; }
    .viewer { position: fixed; inset: 0; width: 100vw; height: 100vh; }
  </style>
  </head>
  <body>
    <object class="viewer" data="${escapedUrl}" type="application/pdf" width="100%" height="100%">
      <embed src="${escapedUrl}" type="application/pdf" width="100%" height="100%" />
      <p>Se il PDF non viene visualizzato, <a href="${escapedUrl}" target="_self" rel="noopener">apri il documento</a>.</p>
    </object>
  </body>
</html>`;
    win.document.open();
    win.document.write(html);
    win.document.close();
  }

}
